import * as React from "react"

import styled from 'styled-components'
import { slide as Menu } from 'react-burger-menu'
import theme from '../Theme'
import { FixedPositionMenuWrapper } from './header/MenuWrapper'
import { MenuNavLink, HeaderNavLink, HeaderNavLinkSpacer } from './header/NavLink'
import { Container, Row, Col } from "react-bootstrap"
import { navigate } from "gatsby"

const navLinks = [
    { name: "Bio", href: "/bio/" },
    { name: "Music", href: "/music/" },
    { name: "Writing", href: "/writing/" },
    { name: "Teaching", href: "/teaching/" },
    { name: "Commissions", href: "/commissions/" },
    { name: "The Keeling Curve", href: "/keelingcurve/" },
  ]


const SiteTitle = props => <div
    aria-hidden="true"
    onClick={() => navigate("/") }
    onKeyDown={() => navigate("/") }
>
  {props.children}
</div>


const SiteTitleBase = styled.span`
font-weight: ${theme.titleFont.fontWeight};
font-family: ${theme.titleFont.fontFamily};
text-transform: ${theme.titleFont.textTransform};
font-size: 28px;
color: ${theme.dark};
cursor: pointer;
`


const SiteTitleMain = styled(SiteTitleBase)`
margin-right: 4px;
`

const SiteTitleHighlight = styled(SiteTitleBase)`
color: ${theme.highlight}
`

const HeaderTag = styled.header`
height: ${theme.header.height};
position: fixed;
top: 0;
left: 0;
width: 100%;
padding-top: 9px;
z-index: 100;
background-color: white;
`

const FlatHeaderTag = styled(HeaderTag)`
height: ${theme.header.flatHeight};
`

const SpacerDiv = styled.div`
height: ${theme.header.height};
margin-bottom: 18px;
`

const FlatSpacerDiv = styled.div`
height: ${theme.header.flatHeight};
margin-bottom: 8px;
`

const LinkContainer = styled.nav`
  margin-top: 4px;
`

const HorizontalLinks = () => {
  const links = []

  for (let i = 0; i < navLinks.length; i++) {
    const link = navLinks[i]
    links.push(<HeaderNavLink to={link.href} key={link.name} href={link.href}>{link.name}</HeaderNavLink>)
    if (i !== navLinks.length - 1) links.push(<HeaderNavLinkSpacer key={link.name + "_spacer"} >/</HeaderNavLinkSpacer>);
  }
  return <LinkContainer>{links}</LinkContainer>
}

const BurgerMenu = () => <FixedPositionMenuWrapper>
    <Menu right>
      <nav>
        <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
          {navLinks.map(link =>
              <li key={link.name}><MenuNavLink to={link.href}>{link.name}</MenuNavLink></li>)}
        </ul>
      </nav>
    </Menu>
  </FixedPositionMenuWrapper>

const SmallHeader = () => <>
  <HeaderTag className="d-sm-none">
    <Container>
      <Row>
        <Col>
          <SiteTitle>
            <SiteTitleMain>Will Frampton</SiteTitleMain>
            <br />
            <SiteTitleHighlight>Composer</SiteTitleHighlight>
          </SiteTitle>
          <BurgerMenu />
        </Col>
      </Row>
    </Container>
  </HeaderTag>
  <SpacerDiv className="d-sm-none" />
</>

const MediumHeader = () => <>
  <FlatHeaderTag className="d-none d-sm-block d-lg-none">
    <Container>
      <Row>
        <Col>
          <SiteTitle>
            <SiteTitleMain>Will Frampton</SiteTitleMain>
            <SiteTitleHighlight>Composer</SiteTitleHighlight>
          </SiteTitle>
          <BurgerMenu />
        </Col>
      </Row>
    </Container>
  </FlatHeaderTag>
  <FlatSpacerDiv className="d-none d-sm-block d-lg-none" />
</>


const LargeHeader = () => <>
  <HeaderTag className="d-none d-lg-block">
    <Container>
      <Row>
        <Col>
          <SiteTitle>
            <SiteTitleMain>Will Frampton</SiteTitleMain>
            <SiteTitleHighlight>Composer</SiteTitleHighlight>
          </SiteTitle>
          <HorizontalLinks />
        </Col>
      </Row>
    </Container>
  </HeaderTag>
  <SpacerDiv className="d-none d-lg-block" />
</>

export const Header = () => <>
  <SmallHeader/>
  <MediumHeader />
  <LargeHeader/>
</>